import Base from "repositories";
import {FacetRequest} from "types/common";
import {
  QuestionReadManyRequest,
  QuestionSearchRequest,
  QuestionSimilarSearchRequest,
  QuestionUpdateRequest
} from "types/question/schema";

class MathQuestion extends Base {
  constructor() {
    super({ prefix: "/math/question" });
  }

  async readMany(payload: QuestionReadManyRequest) {
    return this.axiosInstance.post(``, payload);
  }

  async read(questionId: string) {
    return this.axiosInstance.get(`${questionId}`);
  }

  async readFacets(payload: FacetRequest) {
    return this.axiosInstance.post(`/facets`, payload);
  }

  async update(payload: QuestionUpdateRequest) {
    return this.axiosInstance.put(``, payload);
  }

  async readSimilarMany(payload: QuestionSimilarSearchRequest) {
    return this.axiosInstance.post('/search/similar', payload);
  }

  async search(payload: QuestionSearchRequest) {
    return this.axiosInstance.post('/search', payload);
  }

  async analyzeClassificationResult(questionId: string) {
    return this.axiosInstance.post(`/classification/${questionId}/analyze`);
  }

  async download(fileType: string, payload: QuestionReadManyRequest) {
    return this.axiosInstance.post(
      `/download/${fileType}`,
      payload,
      {
        responseType: "blob"
      });
  }
}

export default new MathQuestion();
